import DonutChart, { DonutSegment } from './DonutChart'
import {
    Card,
    CardHeader,
    CardSubtitle,
    CardTitle,
    ChartRow,
    Legend,
    LegendBadge,
    LegendCompact,
    LegendItem,
    LegendLabel,
} from '../styles'

interface ChartCardProps {
    title: string
    subtitle: string
    segments: DonutSegment[]
    compactLegend?: boolean
    onSegmentClick?: (segment: DonutSegment) => void
}

const ChartCard = ({ title, subtitle, segments, compactLegend = false, onSegmentClick }: ChartCardProps) => {
    const LegendContainer = compactLegend ? LegendCompact : Legend
    const clickable = !!onSegmentClick

    return (
        <Card>
            <CardHeader>
                <CardTitle variant="body_short">{title}</CardTitle>
                <CardSubtitle variant="overline">{subtitle}</CardSubtitle>
            </CardHeader>
            <ChartRow>
                <DonutChart segments={segments} onSegmentClick={onSegmentClick} />
            </ChartRow>
            <LegendContainer>
                {segments.map((segment) => (
                    <LegendItem
                        key={segment.key}
                        type="button"
                        $clickable={clickable}
                        onClick={clickable ? () => onSegmentClick?.(segment) : undefined}
                    >
                        <LegendBadge $color={segment.color}>{segment.value}</LegendBadge>
                        <LegendLabel>{segment.label}</LegendLabel>
                    </LegendItem>
                ))}
            </LegendContainer>
        </Card>
    )
}

export default ChartCard
